import React from 'react';
import { Box, Typography, LinearProgress } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(6),
    },
  })
);

interface ProcessingViewProps {
  title: string;
  subtitle?: string;
}

export function ProcessingView({ title, subtitle }: ProcessingViewProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant='h6' gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant='body2' color='textSecondary' gutterBottom>
          {subtitle}
        </Typography>
      )}
      <Box width='100%' maxWidth={400} mt={3}>
        <LinearProgress />
      </Box>
    </Box>
  );
}
